import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "./slices/authSlice";
import profileReducer from "./slices/profileSlice";
import packageReducer from "./slices/packageSlice";
import notificationReducer from "./slices/notificationSlice";
import helpCenterReducer from "./slices/helpCenterSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "profile"], // Only auth and profile will be persisted
};

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  packages: packageReducer,
  notifications: notificationReducer,
  helpCenterArticles: helpCenterReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
